import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { TimePipe } from './totime.pipe';
import { TextLimitPipe } from './txtLimit.pipe';
import {FormFilterPipe} from './formFilter.pipe';
import { AgenteComponent } from './agente.component';
import { TipificacionComponent } from './tipificacion.component';

@NgModule({
    imports: [FormsModule, ReactiveFormsModule, BrowserModule],
    declarations: [AgenteComponent, TipificacionComponent, TimePipe, TextLimitPipe, FormFilterPipe],
    exports: [TimePipe, AgenteComponent, TipificacionComponent, TextLimitPipe, FormFilterPipe]
})
export class agenteConsoleModule {
    
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/agente/agente.module.ts